import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { MostRequestHistoryStatus } from 'src/graphql/generated/graphql';
import { MostFilterResultType, TabType } from '../list';
import UserInfoPopper from './user-info-popper';
import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { StoresServerSideField } from 'src/components/common/stores/stores-serverside';

export const getFilterConfig = ({
  t,
  size,
  activeTab,
}: {
  t: TFunction;
  size: number;
  activeTab: TabType;
}) => [
  {
    id: 'userId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      disabled: activeTab === TabType.Favourite,
      inputProps: {
        placeholder: t('most.list.filter.user'),
        name: 'userId',
        label: <UserInfoPopper />,
      },
    },
  },
  {
    id: 'status',
    size,
    type: FilterItemType.Select,
    props: {
      disabled: activeTab !== TabType.History,
      inputProps: {
        placeholder: t('common.status.label'),
        name: 'status',
        label: t('common.status.label'),
      },
      options: [
        {
          value: MostRequestHistoryStatus.Completed,
          name: t('common.status.completed'),
        },
        {
          value: MostRequestHistoryStatus.Failed,
          name: t('common.status.failed'),
        },
        {
          value: MostRequestHistoryStatus.Pending,
          name: t('common.status.pending'),
        },
        {
          value: MostRequestHistoryStatus.Processing,
          name: t('common.status.processing'),
        },
        {
          value: MostRequestHistoryStatus.Waiting,
          name: t('common.status.waiting'),
        },
      ],
    },
  },
  {
    id: 'storeIds',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <StoresServerSideField
        {...props}
        multiple
        useCheckboxOption
      ></StoresServerSideField>
    ),
    props: {
      multiple: true,
      inputProps: {
        placeholder: t('most.list.filter.stores'),
        name: 'storeIds',
        label: t('most.list.filter.stores'),
      },
    },
  },
  {
    id: 'results',
    size,
    type: FilterItemType.Select,
    props: {
      disabled: activeTab !== TabType.History,
      disableClearable: true,
      inputProps: {
        placeholder: t('most.list.filter.results.label'),
        name: 'results',
        label: t('most.list.filter.results.label'),
      },
      options: [
        {
          value: MostFilterResultType.Alerts,
          name: t('most.list.filter.results.alerts-only'),
        },
        {
          value: MostFilterResultType.Recent,
          name: t('most.list.filter.results.recent'),
        },
        {
          value: MostFilterResultType.All,
          name: t('most.list.filter.results.all'),
        },
      ],
    },
  },
];
